<template>
    <div>
        <div style="text-align: left;">
            <div style="display: inline-block; margin: 10px; vertical-align: top;">
                <div style="padding: 5px; font-size: 14px; display: inline-block;">LOCATION</div>
                <b-form-select
                  v-model="picked_location"
                  :options="locations"
                  style="width: 200px; display: inline-block;"
                  size="md"
                ></b-form-select>
                <b-button size="sm" variant="success" :disabled="actions_disabled" @click="fetchInventory">SUBMIT</b-button>
            </div>
        </div>

        <b-overlay :show="items_being_loaded" rounded="sm">
            <div style="text-align: right;" v-if="items.length > 0">
                <div style="padding: 5px; font-size: 14px; display: inline-block;">FILTER</div>
                <b-input 
                    style="width: 300px; margin-left: auto; margin-bottom: 10px; display: inline-block;"
                    v-on:keyup="filterItems"
                    v-model="filter_value"
                ></b-input>
            </div>
            <div v-if="items.length > 0" style="border: 1px solid #efefef;">
                
                <div>
                    <table style="width: 100%;">
                        <thead>
                            <tr style="background: crimson; color: white; font-weight: bold;">
                                <td class="ipt_tdhr" v-on:click="sortby('product_id')">
                                    ID
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('product_sku')">
                                    SKU
                                </td>
                                <td class="ipt_tdhr">
                                    PRODUCT
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('category')">
                                    CATEGORY
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('vendor')">
                                    VENDOR
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('sublocation_id')">
                                    SUBLOC
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('nitems')">
                                    COUNT
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in items_to_show">
                                <td class="ipt_tdr">
                                    {{item.product_id}}
                                </td>
                                <td class="ipt_tdr">
                                    {{item.product_sku}}
                                </td>
                                <td class="ipt_tdr">
                                    {{item.product_name}}
                                </td>
                                <td class="ipt_tdr">
                                    {{item.category}}
                                </td>
                                <td class="ipt_tdr">
                                    {{item.vendor}}
                                </td>
                                <td class="ipt_tdr">
                                    {{sublocationsdict[item.sublocation_id]}}
                                </td>
                                <td class="ipt_tdr" style="width: 100px; text-align: left;">
                                    <b-input size="sm" style="width: 60px; text-align: left; display: inline;" v-model="item.nitems" v-on:keyup="show_edits[idx]=true" v-on:keydown="show_edits[idx]=true"></b-input>
                                    
                                    <span v-if="show_edits[idx]">
                                        <b-badge style="padding: 5px; background: crimson; color: white; font-weight: bold; font-size: 14px; cursor: pointer;" @click="updateInventoryNumber(item, idx)">U</b-badge>      
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import global_vars from '@/utilities/global_vars'
    import moment from 'moment'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'  

    export default {
        name: "ListInventory",
        props: ["showbacker"],
        components: {Backer, Multiselect},
        data: function(){
            return {
                userDetails: {properties: {}},
                picked_location: null,
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                items: [],
                items_to_show: [],
                items_being_loaded: false,
                sort_asc: true,
                actions_disabled: false,
                filter_value: null,
                show_edits:{},
            }
        },
        methods: {
            filterItems: function(value){
                if (this.filter_value){
                    this.items_to_show = this.items.filter(item => {
                        return (
                            ( 
                            item.product_name.toLowerCase().indexOf(this.filter_value.toLowerCase()) > -1
                            ||
                            item.product_sku.toLowerCase().indexOf(this.filter_value.toLowerCase()) > -1
                            ||
                            JSON.stringify(item.product_id).toLowerCase().indexOf(this.filter_value.toLowerCase()) > -1
                            )
                        );
                    })
                }
                else {
                    this.items_to_show = this.items;
                }
            },
            fetch_prereqs: function(){
                let that = this;

                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name}
                                });

                                that.locations.splice(0, 0, {value: null,  text: "All"});

                                if (that.userDetails.userrole == 'locationadmin' || that.userDetails.userrole == 'locationuser'){
                                    let user_location = parseInt(that.userDetails.properties.location_id);

                                    that.locations = that.locations.filter(function(d){return d.value == user_location});
                                }
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            fetchInventory: function(e){
                if (e){
                    e.preventDefault()
                }

                if (this.picked_location == null){
                    this.$vex.dialog.alert({message: "Please pick a location to fetch its inventory counts."});
                    return
                }

                let that = this;
                let data = {
                    location_id: this.picked_location,
                }

                let path = "/api/inventory/get_inventory_for_location/"
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        that.items_to_show = response.data.result;
                        that.show_edits = {}
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }
                
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading inventory.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                this.items_being_loaded = true
                this.actions_disabled = true
                Requestor.getSyncP(path, data, this, s, f);
                
            },
            updateInventoryNumber: function(item, idx){
                let nitems = item.nitems;

                if (isNaN(parseInt(nitems))){
                    this.$vex.dialog.alert({message: "Invalid quantity. Not updated"});
                    return
                }

                let that = this;
                let path = "/api/inventory/update_single_product_to_inventory/";
                let data = item;
                data.nitems = parseInt(nitems);
                data.location_id = this.picked_location;
                let s = function(response){
                    if (response.data.result){
                        that.show_edits[idx] = false
                        that.$bvToast.toast(
                            "Inventory count updated.", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.actions_disabled = false
                }
                
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error updating inventory count. Nothing changed.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.actions_disabled = false
                }
                Requestor.postAsyncP(path, data, this, s, f);

            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                
            }
        }
    }
</script>

<style scoped>
    td {
        padding: 3px;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListInventory.vue